export function hasPermission(userScopes: string[], requiredScope: string): boolean {
  return userScopes.includes(requiredScope);
}

export function hasAnyPermission(userScopes: string[], requiredScopes: string[]): boolean {
  return requiredScopes.some(scope => userScopes.includes(scope));
}

export function hasAllPermissions(userScopes: string[], requiredScopes: string[]): boolean {
  return requiredScopes.every(scope => userScopes.includes(scope));
}
